import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, User } from 'lucide-react';
import { blogService } from '../../services/db';

const FeaturedBlog = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const allPosts = await blogService.getPosts();
                // Take the first 3 posts
                setPosts(allPosts.slice(0, 3));
            } catch (error) {
                console.error("Failed to fetch featured posts", error);
            } finally {
                setLoading(false);
            }
        };

        fetchPosts();
    }, []);

    if (loading || posts.length === 0) return null;

    return (
        <section className="py-24 bg-zinc-900 border-t border-zinc-800">
            <div className="container mx-auto px-6">
                <div className="max-w-4xl mb-16">
                    <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-6">
                        Investigación Reciente
                    </h2>
                    <p className="text-xl text-zinc-400 max-w-2xl font-light">
                        Nuestra biblioteca de pensamientos, policy papers y reportes técnicos sobre el futuro de Iztacalco.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {posts.map((post) => (
                        <Link
                            to={`/blog/${post.slug}`}
                            key={post.slug}
                            className="group flex flex-col h-full bg-surface border border-zinc-800 rounded-xl overflow-hidden hover:border-primary/50 transition-colors"
                        >
                            <div className="aspect-video relative overflow-hidden bg-zinc-800">
                                {post.imageUrl ? (
                                    <img
                                        src={post.imageUrl}
                                        alt={post.title}
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                    />
                                ) : (
                                    <div className="w-full h-full flex items-center justify-center text-zinc-700">
                                        <span className="font-mono text-xs">NO IMAGE</span>
                                    </div>
                                )}
                                <div className="absolute inset-0 bg-gradient-to-t from-background/90 to-transparent opacity-60" />
                            </div>

                            <div className="p-6 flex flex-col flex-1">
                                <div className="flex items-center gap-4 text-xs font-mono text-zinc-500 mb-4">
                                    {post.publishedAt && (
                                        <span className="flex items-center gap-1">
                                            <Calendar className="w-3 h-3" />
                                            {new Date(post.publishedAt).toLocaleDateString('es-MX', { year: 'numeric', month: 'short', day: 'numeric' })}
                                        </span>
                                    )}
                                </div>

                                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-primary transition-colors line-clamp-2">
                                    {post.title}
                                </h3>

                                <p className="text-zinc-400 text-sm leading-relaxed mb-6 line-clamp-3">
                                    {post.excerpt}
                                </p>

                                <div className="mt-auto flex items-center text-primary text-sm font-medium">
                                    Leer artículo <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>

                <div className="mt-12 text-center">
                    <Link to="/blog" className="inline-flex items-center text-zinc-400 hover:text-white transition-colors font-mono text-sm border-b border-zinc-700 hover:border-white pb-0.5">
                        VER ARCHIVO COMPLETO
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default FeaturedBlog;
